import { AnalyticsDashboardService } from '@/services/analytics-dashboard-service';
import { useQuery } from '@tanstack/react-query';

/**
 * The access call answers `Cache-Control: no-store`, so nothing is kept once
 * the page unmounts. It is repeated when the tab regains focus (never on an
 * interval) so a new published week or a revoked permission is picked up.
 */
export const useAnalyticsDashboardAccess = () =>
  useQuery({
    queryKey: ['analyticsDashboardAccess'],
    queryFn: AnalyticsDashboardService.getAccess,
    gcTime: 0,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: 'always',
  });
